;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();import { FormFeedback, Input, Label } from 'reactstrap';
import capitalizeFirstLetter from '../utils/capitalizeFirstLetter';
import { getI18nUtils } from '../i18n/i18n-utils';
import { Dictionaries } from '../i18n/i18n-config';

function FileUploadButton({
  id,
  name,
  labelName,
  changed,
  fileTypes,
  invalid,
  valid,
  required = false,
  formFeedback,
  dictionary,
}: {
  id: string;
  name: string;
  labelName: keyof Dictionaries;
  changed: (uploadEvent: React.ChangeEvent<HTMLInputElement>, side?: 'front' | 'back') => void;
  fileTypes: string;
  invalid: boolean;
  valid: boolean;
  required?: boolean;
  formFeedback?: keyof Dictionaries;
  dictionary: Record<string, string>;
}): JSX.Element {
  const { formatMessage } = getI18nUtils(dictionary);

  return (
    <div id="fileUploadButton">
      <Label for={id} className="file-title text-muted mb-1">
        {capitalizeFirstLetter(formatMessage({ id: labelName }))}
        {required && '*'}
      </Label>
      <Input
        accept={fileTypes}
        type="file"
        id={id}
        name={name}
        onChange={changed}
        invalid={invalid}
        valid={valid}
        required={required}
        className="py-1"
      />
      {formFeedback && <FormFeedback>{formatMessage({ id: formFeedback })}</FormFeedback>}
    </div>
  );
}

export default FileUploadButton;
